import React, { FunctionComponent } from "react";
import { EditWarrantyForm } from "../../components/EditWarrantyForm";

export const EditWarranty: FunctionComponent = (): JSX.Element => {
    return (
        <EditWarrantyForm />
    )
}